import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 1 1v8a6 6 0 1 1 -12 0v-8a1 1 0 0 1 1 -1h1v-4a1 1 0 0 1 1 -1zm-1 2h-4v3h4z","key":"svg-0"}]]

/**
 * IconDeviceUsbFilled
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0iY3VycmVudENvbG9yIgogIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb25zLXRhYmxlci1maWxsZWQgaWNvbi10YWJsZXItZGV2aWNlLXVzYiIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTUgMmExIDEgMCAwIDEgMSAxdjRoMWExIDEgMCAwIDEgMSAxdjhhNiA2IDAgMSAxIC0xMiAwdi04YTEgMSAwIDAgMSAxIC0xaDF2LTRhMSAxIDAgMCAxIDEgLTF6bS0xIDJoLTR2M2g0eiIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/device-usb-filled
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconDeviceUsbFilled = createReactComponent('filled', 'device-usb-filled', 'DeviceUsbFilled', __iconNode);

export default IconDeviceUsbFilled;